export class MoneticoPaymentInfo {
  Action: string;
  Version: string;
  TPE: string;
  Date: string;
  Montant: string;
  Reference: string;
  MAC: string;
  URLRetour: string;
  URLRetourOk: string;
  URLRetourErr: string;
  Langue: string;
  Societe: string;
  TexteLibre: string;
  Mail: string;
}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/models/monetico-payment-info.ts